import { useCallback } from 'react';

import { AssetDto, PrivateDocumentDto } from '@/shared/lib/sj-orm';
import { useSjActions } from '@/shared/lib/sj-orm/hooks/useSjActions';
import { DtoId } from '@/shared/lib/sj-orm/models/base.dto';

export enum DocumentsGroup {
  ASSET_ACQUISITIONS = 'ASSET_ACQUISITIONS',
  SOURCES_OF_ACQUISITION = 'SOURCES_OF_ACQUISITION',
  PROOFS_OF_OWNERSHIP = 'PROOFS_OF_OWNERSHIP',
  PAYMENT_METHODS = 'PAYMENT_METHODS',
  POWERS = 'POWERS',
  ACCESS_LIMITATIONS = 'ACCESS_LIMITATIONS',
  ASSET_PROTECTIONS = 'ASSET_PROTECTIONS',
  OTHERS = 'OTHERS',
}

export const useAssetDocuments = () => {
  const sjPrivateDocs = useSjActions('privateDocuments');

  const getAssetDocuments = useCallback(
    (asset: AssetDto) => {
      const getDtoList = (ids: DtoId[]) => {
        return ids.map((id) => sjPrivateDocs?.findById(id)).filter((item) => item !== undefined);
      };

      const docGroups: Record<DocumentsGroup, PrivateDocumentDto[]> = {
        [DocumentsGroup.ACCESS_LIMITATIONS]: getDtoList(asset.accessLimitations ?? []),
        [DocumentsGroup.ASSET_ACQUISITIONS]: getDtoList(asset.assetAcquisitions ?? []),
        [DocumentsGroup.ASSET_PROTECTIONS]: getDtoList(asset.assetProtections ?? []),
        [DocumentsGroup.OTHERS]: getDtoList(asset.otherDocuments ?? []),
        [DocumentsGroup.PAYMENT_METHODS]: getDtoList(asset.paymentMethods ?? []),
        [DocumentsGroup.POWERS]: getDtoList(asset.powersOfAttorney ?? []),
        [DocumentsGroup.PROOFS_OF_OWNERSHIP]: getDtoList(asset.proofsOfOwnership ?? []),
        [DocumentsGroup.SOURCES_OF_ACQUISITION]: getDtoList(asset.sourcesOfAcquisition ?? []),
      };

      const allDocs = Object.values(docGroups).reduce<PrivateDocumentDto[]>((acc, cur) => {
        return acc.concat(cur);
      }, []);

      return {
        all: allDocs,
        groups: docGroups,
      };
    },
    [sjPrivateDocs],
  );

  return { getAssetDocuments };
};
